<template>
<div v-if="comp && comp.loaded()">
  <!-- if registration is closed -->
  <div v-if="comp.registrationEnded() ">
    <b-button v-if="forceButton" variant="secondary" size="sm" :disabled=true>Anmeldung beendet</b-button>
    <span v-else>Anmeldung beendet</span>
  </div>

  <!-- if registration is not open yet -->
  <div v-else-if="!comp.registrationStarted()">
    <b-button v-if="forceButton" variant="secondary" size="sm" :disabled=true>Anmeldung ab {{ comp.getRegistrationStart() | moment('D. MMMM') }}</b-button>
    <span v-else>Anmeldung ab {{ comp.getRegistrationStart() | moment('D. MMMM') }}</span>
  </div>

  <!-- if registered -->
  <div v-else-if="registration && registration.registered()">
    <b-button variant="primary"
              size="sm"
              :to="{
                        name: 'teacher.competition.registration',
                        params:{ id: comp.id, from: this.$route},
                        query: { id: registration.id }
                      }"
    >Anmeldung bearbeiten
    </b-button>
  </div>

  <!-- if registration is open but NOT registered -->
  <div v-else>
    <b-button variant="primary"
              size="sm"
              :to="{
                  name: 'teacher.competition.registration',
                  params:{ id: comp.id, from: this.$route}
                }">anmelden
    </b-button>
  </div>

</div>
</template>
<script>
import {Competition} from '@/models'
export default {
  name: 'CompetitionRegistrationButton',
  props: ['competition', 'competitionId', 'registration', 'from', 'forceButton'],
  data: function () {
    return {
      comp: null
    }
  },
  mounted: function () {
    if (this.competition) {
      this.comp = this.competition
      return
    }

    if (this.competitionId) {
      this.comp = new Competition({id: this.competitionId})
      this.comp.fetch()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/competitions/registration/Button.vue